/* eslint-disable prettier/prettier */
import {
  VENDAS_ONLINE_PARCEIRO_FETCHED,
  VENDAS_ONLINE_PARCEIRO_DETAIL_FETCHED,
  VENDAS_ONLINE_PARCEIRO_LOADING,
  VENDAS_ONLINE_PARCEIRO_RESET,
  VENDAS_ONLINE_PARCEIRO_PARTNERS_FETCHED,
  VENDAS_ONLINE_PARCEIRO_CATEGORIES_FETCHED,
  VENDAS_ONLINE_PARCEIRO_GROUPINGS_FETCHED,
  VENDAS_ONLINE_PARCEIRO_STATIONS_FETCHED,
} from './types';

const INITIAL_STATE = {
  list: [],
  detail: {},
  partners: [],
  categories: [],
  groupings: [],
  stations: [],
  loading: false,
  totalCount: 0,
};

export default function vendasOnlineParceiroReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case VENDAS_ONLINE_PARCEIRO_FETCHED:
      return {
        ...state,
        list: action.payload.list || [],
        totalCount: action.payload.totalCount || 0,
        loading: false,
      };
    case VENDAS_ONLINE_PARCEIRO_DETAIL_FETCHED:
      return {
        ...state,
        detail: action.payload,
        loading: false,
      };
    case VENDAS_ONLINE_PARCEIRO_PARTNERS_FETCHED:
      return {
        ...state,
        partners: action.payload || [],
      };
    case VENDAS_ONLINE_PARCEIRO_CATEGORIES_FETCHED:
      return {
        ...state,
        categories: action.payload || [],
      };
    case VENDAS_ONLINE_PARCEIRO_GROUPINGS_FETCHED:
      return {
        ...state,
        groupings: action.payload || [],
      };
    case VENDAS_ONLINE_PARCEIRO_STATIONS_FETCHED:
      return {
        ...state,
        stations: action.payload || [],
      };
    case VENDAS_ONLINE_PARCEIRO_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case VENDAS_ONLINE_PARCEIRO_RESET:
      return INITIAL_STATE;
    default:
      return state;
  }
}
